import React, { FC } from 'react';
import { Sticky as ReactSticky } from 'react-sticky';
import { StickyWrapper } from 'components/atoms/sticky-wrapper';
import { ClassNameProps } from 'components/ozone-component';

interface Props extends ClassNameProps {
  top: number;
  layer?: number;
}

/**
 * @param top - Distance from top
 * @param layer - Z-index layer, check varables.css
 */
export const Sticky: FC<Props> = ({ className, top, layer, children }) => (
  <ReactSticky relative topOffset={-1 * top}>
    {({ style, isSticky }) => (
      <StickyWrapper
        className={className}
        top={top}
        sticky={isSticky}
        layer={layer}
        style={style}
      >
        {children}
      </StickyWrapper>
    )}
  </ReactSticky>
);
